import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormAssessmentTemplate from './form-assessment-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateAssessmentItemTemplate } from 'works/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function EditAssessmentTemplate({ dismiss, item, form }) {
  const handleMutationCompletion = (response) => {
    if (response.updateAssessmentItemTemplate.errors) {
      addErrorsToForm(form, response.updateAssessmentItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateAssessment] = useMutation(UpdateAssessmentItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    updateAssessment({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    assessmentId: item.assessment.id,
    issuersId: item.assessmentIssuers.map((i) => i.id),
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
  };

  return (
    <FormAssessmentTemplate
      initialValues={initialValues}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      showExpiration
      form={form}
      currentAssessment={item.assessment}
      currentIssuers={item.assessmentIssuers}
    />
  );
}

EditAssessmentTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
